module.exports = __webpack_public_path__ + "img/logo-round.34d35b47.png";